import { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import { api, formatRupiah, formatDate } from "../lib/api";
import { PiggyBank } from "lucide-react";

export default function MemberSimpanan() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/member/simpanan").then((r) => setRows(r.data)); }, []);
  const totals = rows.reduce(
    (acc, r) => { acc[r.type] = (acc[r.type] || 0) + Number(r.amount); return acc; }, {}
  );

  return (
    <MemberLayout>
      <div className="space-y-5">
        <h1 className="font-heading font-extrabold text-3xl tracking-tight text-brand-ink">Simpanan Saya</h1>

        <div className="grid grid-cols-3 gap-2">
          {["pokok", "wajib", "sukarela"].map((t) => (
            <div key={t} className="rounded-2xl bg-white border border-brand/10 p-4">
              <div className="text-[10px] uppercase tracking-[0.18em] text-brand-muted">{t}</div>
              <div className="font-heading font-bold text-brand-ink mt-1 text-lg sm:text-xl">{formatRupiah(totals[t] || 0)}</div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-3xl border border-brand/10 shadow-sm overflow-hidden">
          <div className="px-5 py-4 border-b border-brand/10 font-heading font-bold text-brand-ink">Riwayat Transaksi</div>
          {rows.length === 0 ? (
            <div className="p-8 text-center text-brand-muted text-sm">Belum ada transaksi simpanan.</div>
          ) : (
            <ul className="divide-y divide-brand/10" data-testid="member-simpanan-list">
              {rows.map((r) => (
                <li key={r.id} className="px-5 py-3 flex items-center justify-between">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="w-9 h-9 rounded-xl bg-brand-soft text-brand flex items-center justify-center"><PiggyBank size={16} /></div>
                    <div className="min-w-0">
                      <div className="font-medium text-brand-ink capitalize truncate">Simpanan {r.type}</div>
                      <div className="text-xs text-brand-muted">{formatDate(r.transaction_date)} · {r.note || "-"}</div>
                    </div>
                  </div>
                  <div className="font-semibold text-brand-ink whitespace-nowrap">{formatRupiah(r.amount)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </MemberLayout>
  );
}
